module.exports = __webpack_public_path__ + "img/rise.984f041c.svg";